import { bigdataRequest } from './axios'
import qs from 'qs'

let baseUrl = '/v1/api/goodsStatistics/';

export default {
  shopList() {
    return bigdataRequest.get(baseUrl + 'shopList').then(res => res.data)
  },
  page(data) {
    return bigdataRequest.get(baseUrl + 'page', {
      params: data
    }).then(res => res.data);
  },
  searchByAsin(data) {
    return bigdataRequest.get(baseUrl + 'searchByAsin', {
      params: data
    }).then(res => res.data);
  },
  addCompetitorRelation(data) {
    return bigdataRequest.post(baseUrl + 'addCompetitorRelation', qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => res.data);
  },
}
